// extracted by mini-css-extract-plugin
export default {"button":"VariantAdd_button__-85mI"};